<template>
<!--答题卡正确-->
  <div id="examresult">
    <h2 class="title">
      <a href="" class="prev"></a>
      <b>1</b>/20
    </h2>
    <h3 class="type">单选题 <span>0/12</span></h3>
    <div class="question-num">
      <a href="" target="_blank" class="blue">1</a>
      <a href="" target="_blank" class="blue">2</a>
      <a href="" target="_blank" class="blue">3</a>
      <a href="" target="_blank" class="blue">4</a>
      <a href="" target="_blank" class="blue">5</a>
      <a href="" target="_blank" class="blue">6</a>
      <a href="" target="_blank" class="blue">7</a>
      <a href="" target="_blank" class="blue">8</a>
      <a href="" target="_blank" class="blue">9</a>
      <a href="" target="_blank" class="blue">10</a>
      <a href="" target="_blank" class="blue">11</a>
      <a href="" target="_blank" class="blue">12</a>
      <a href="" target="_blank">13</a>
      <a href="" target="_blank">14</a>
      <a href="" target="_blank">15</a>
      <a href="" target="_blank">16</a>
      <a href="" target="_blank">17</a>
      <a href="" target="_blank">18</a>
    </div>
    <a href="" class="fixed-bar">结束作答</a>
  </div>
</template>

<script>
export default {
  name: 'ExamResult'
}
</script>

<style scoped lang="stylus">
  #examresult
    h2.title
      position: relative
      height: 1.08rem
      line-height: .8rem
      background-color: transparent
      padding: .14rem .16rem
      font-size: .32rem
      color: #A3A9B7
      font-weight: 600
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      b
        font-size: .48rem
        color: #FF7052
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        display: block
        width: .8rem
        height: .8rem
        background-color: transparent
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #050505
          border-bottom: .03rem solid #050505
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
    h3.type
      position: relative
      padding: 0 .4rem
      margin: .3rem 0
      font-size: .48rem
      color: #050505
      font-weight: 600
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      span
        position: absolute
        top: .2rem
        right: .5rem
        font-size: .28rem
        color: #1E81F2
        font-weight: 400
    .question-num
      display: flex
      justify-content: space-between
      align-items: center
      align-content: space-around
      flex-wrap: wrap
      padding: 0 .31rem
      a
        display: block
        width: .8rem
        height: .8rem
        line-height: .8rem
        border: .02rem solid #D8D8D8
        margin: .1rem .17rem
        font-size: .36rem
        color: #333
        text-align: center
        -webkit-border-radius: .08rem
        -moz-border-radius: .08rem
        border-radius: .08rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        &.blue
          background-color: #1E81F2
          border-color: #1E81F2
          color: #fff
        &.red
          background-color: #FF7052
          border-color: #FF7052
          color: #fff
    a.fixed-bar
      position: fixed
      bottom: .4rem
      left: 50%
      display: block
      width: 6.54rem
      height: .8rem
      line-height: .8rem
      background-color: #FF7052
      color: #fff
      font-size: .36rem
      text-align: center
      -webkit-border-radius: .49rem
      -moz-border-radius: .49rem
      border-radius: .49rem
      -webkit-transform: translate(-50%, 0)
      -moz-transform: translate(-50%, 0)
      -ms-transform: translate(-50%, 0)
      -o-transform: translate(-50%, 0)
      transform: translate(-50%, 0)
</style>



// WEBPACK FOOTER //
// src/components/exam/ExamResult.vue